import { getSubdomain } from 'tldts';

export const fetchSubDomain = () => {
	const subDomain = getSubdomain(window.location.host, {
		validHosts: ['localhost'],
	});

	return subDomain;
};
